import {
  TechDocsReaderPageHeader,
  TechDocsReaderPageContent,
  TechDocsReaderPageSubheader,
} from '@backstage/plugin-techdocs';
import { Page } from '@backstage/core-components';

const DefaultTechDocsPage = () => {
  return (
    <Page themeId="documentation">
      <TechDocsReaderPageHeader />
      <TechDocsReaderPageSubheader />
      <TechDocsReaderPageContent withSearch={false} />
    </Page>
  );
};

export const techDocsPage = <DefaultTechDocsPage />;
